import { createSelector } from 'reselect';
import { getAllCookies } from 'common/selectors';
import { SHOPPING_LIST_COOKIE_KEY } from 'common/constants';
import { RootState } from 'typesafe-actions';

export const getShoppingListCookie = createSelector(
  getAllCookies,
  (cookies) => cookies?.[SHOPPING_LIST_COOKIE_KEY] as string | undefined,
);

export const getIsInWishList = (state: RootState, itemId: string): boolean => {
  const shoppingListCookie = getShoppingListCookie(state);
  return !!shoppingListCookie?.includes(itemId);
};
